module.exports = __webpack_public_path__ + "img/comments_widget.faf63529.jpg";